<template>
  <div class=" is-fullwidth">

    <div class="level">
        <div class="level-left">
          <div class="columns" >
              <div class="col ">
                <select v-model="cutting_location_id" class="select input" @change="getOrders()">
                  <option value="">Select Cutting Location ...</option>  
                  <option :value="row.id" v-for="row in cutting_rooms" :key="row.id">{{  row.name }}</option>
                </select>
              </div>

             <div class=" col">
                &nbsp;<input type="date" class="input" v-model="start_date" @change="getOrders()"/>
                
              </div>
              <div class=" col" >
                &nbsp;<input type="date" class="input" v-model="end_date" @change="getOrders()"/>
                
              </div>

              <div class="col ">
                <div class="buttons">
                <button class="button is-light">{{ filteredOrders.length }} orders</button>
                 <button class="button is-light">{{this.total_garment_cut}}  garments</button>
                </div>
                </div>
           
            <div class="ml-4 col">
              <button @click="exportXLS()" class="button is-info" >Export to Excel</button>
            </div>
          </div>
      </div>
        
      </div>

    <div class="">
      <button class="button is-warning is-pulled-right mb-2" style="display:none">Export to CSV</button>
    </div>
    
    <div class="notification is-info" v-if="loading == true" >Loading orders ...</div>
    <div class="notification is-warning" v-if="loading === false && filteredOrders.length == 0">
            <p>There are no orders to display</p>
        </div>

        
    <table class="table is-hoverable is-fullwidth is-size-7" id="fulltable" v-if="loading == false && filteredOrders.length > 0">
    	<thead>
      <tr>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th >Order Date
            
          </th>
          <th >Delivery
           
          </th>
          <th>Qty Cut</th>
          <th>Cutting Room</th>
          <th>Producer</th>
        </tr>
    	</thead>
    	<tbody>
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID" >
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.orderdate}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.qty_cut }} / {{  order.total_qty }}</td>
          <td>
            {{ order.cutting_location_name }}

          </td>
          <td> {{  order.makeup_location_name }}</td>    
			</tr>
    	</tbody>
    </table>

    <table class="" id="orderstable" v-if="loading == false && filteredOrders.length > 0" style="display:none">
    	<thead>
    		<tr>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th >Order Date
            
          </th>
          <th >Delivery
           
          </th>
          <th>Total Qty</th>
          <th>Qty Cut</th>
          <th>Cutting Room</th>
          <th>Producer</th>
        </tr>
    	</thead>
    	<tbody>
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID" >
        
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.orderdate_raw}}</td>
          <td>{{order.deliverydate_raw}}</td>
          <td>{{  order.total_qty }}</td>
          <td>{{ order.qty_cut }}</td>
          <td>
            {{ order.cutting_location_name }}

          </td>
          <td> {{  order.makeup_location_name }}</td>    
			</tr>
    	</tbody>
    </table>
    
    
    
    
  </div>
</template>

<script>
import XLSX from 'xlsx';

import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      cutting_rooms: [],
     order_by: 'deliverydate ASC',
     limit:'',
     start_date: '',
        end_date: '',
        cutting_location_id: ''
    }
  },
   methods: {
    exportXLS() {
      //alert("hi")
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet JS"});
      XLSX.writeFile(wb, 'Cutting Report.xlsx')

    },
      async getOrders() {
        this.loading=true
        OrderService.getCutSewCuttingsReport(this.accessToken, this.start_date, this.end_date, this.cutting_location_id)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
    
    async processOrder(order) {
        this.working = true
        
        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             cutting_location_id: order.cutting_location_id
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            //console.log(response)
            order.cutting_processed = 1
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async markUrgent(order) {
        this.working = true
        
        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             cutting_urgent: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            order.cutting_urgent = 1
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async getRanges() {
        UtilityService.getSimpleApiData(this.accessToken, "ranges").then(
               response => this.ranges = response 
            );
      },
      async getCuttingRooms() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?cutting=1").then(
               response => this.cutting_rooms = response 
            );
      },
      getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
        },
    
  },
  computed : {
      filteredOrders: function () {
       
        /*let filteredOrders =  this.orders.filter(function(u) {
            if(  u.cutting_processed == 0) 
            {
              return 1
            }
          })*/

          let filteredOrders = this.orders

       

          return filteredOrders
       
     },
     total_garments: function () {
        return this.filteredOrders.reduce((total, order) => total + order.total_qty, 0);
     },
     total_garment_cut: function () {
        return this.filteredOrders.reduce((total, order) => total + order.qty_cut, 0);
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getCuttingRooms();
        });
  },
 
  mounted() {
    if (localStorage.cuttingreport_start_date) {
      this.start_date = localStorage.cuttingreport_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }

    if (localStorage.cuttingreport_end_date) {
      this.end_date = localStorage.cuttingreport_end_date;
    }
    else{
      this.end_date = new Date().toISOString().slice(0,10)
    }

    if (localStorage.cuttingreport_cutting_location_id) {
      this.cutting_location_id = localStorage.cuttingreport_cutting_location_id;
    }
    else{
      this.cutting_location_id = ''
    }
      
  },
  watch: {
    
    start_date: function () {
      localStorage.cuttingreport_start_date = this.start_date;
     
    },
    end_date: function () {
      localStorage.cuttingreport_end_date = this.end_date;
      
    },
    cutting_location_id: function () {
      localStorage.cuttingreport_cutting_location_id = this.cutting_location_id;
      
    },
    
    
  }
}


</script>

